import { ButtonLink } from "../../../components/buttons/button-link.tsx";
import { FontStyles } from "../../../utils/font-styles.ts";
import { cn } from "../../../utils/cn.ts";
import "../../../../assets/fa-icons/css/fontawesome.css";
import "../../../../assets/fa-icons/css/sharp-regular.css";

interface PropertyVideoProps {
  url?: string;
  isVideoExternalRedirect?: boolean;
  isConstrainedView?: boolean;
}

export const PropertyVideo = ({ url, isVideoExternalRedirect, isConstrainedView }: PropertyVideoProps) => (
  <div className={cn("w-full flex bg-neutral-50", isConstrainedView ? "" : "h-full")}>
    {!isVideoExternalRedirect && (
      <iframe
        src={url}
        className={cn(
          "bg-black ",
          isConstrainedView ? "aspect-video max-w-espc-max-content mx-auto w-full " : "w-full h-full ",
        )}
        allowFullScreen
        title="Property video"
      />
    )}
    {isVideoExternalRedirect && (
      <div className={"flex flex-col justify-center items-center gap-5 text-center w-full px-3.5 "}>
        <p className={cn(FontStyles["body-l"], "text-slate")}>
          This video is hosted externally and will open in a new browser tab.
        </p>
        <ButtonLink
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          renderLeadingIcon={() => (
            <i className="fa-sharp fa-regular fa-arrow-up-right-from-square" aria-hidden="true" />
          )}
          label={"Open video"}
          colorVariant={"secondary"}
          variant={"solid"}
        />
      </div>
    )}
  </div>
);
